import React, { useState, useRef, useEffect, useContext } from "react";
import { baseUrl } from '../../config.js'
import { Chart } from "react-google-charts";

import './Dashboards.css';

import useToken from "../../useToken.js";
import { formatoFecha, formatoFechaCorta, formatoMoneda, formatoHora, Meses, estatus, imgEstatus } from '../../almacen.js';

import Terminado from '../../img/Terminado.png';
import EnCurso from '../../img/EnCurso.png';
import Terminar from '../../img/Terminar.png';
import Esperando from '../../img/Created.png';
import Iniciar from '../../img/Iniciar.png';
import Cerrar from '../../img/Cerrar.png';
import FlechaGuia from '../../img/Guia.png';

import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";

const Conds = {
    "0": "Exactamente",
    "1": "Entre",
    "2": "Más de",
    "3": "Menos de",
}
const CondsFecha = {
    "0": "",
    "1": "",
    "2": "A partir del",
    "3": "Antes del",
}

const DashInouts = ({solicitudes, setId})=>{

    const location = useLocation();

    return(
        <div className="dashEspacios dashInouts">
            <div className="movimientos">
                <div className="etiqueta">
                    <div>
                        <h2 style={{margin:'0 0 1.25rem 0', fontSize:'1.4rem', fontWeight:700, color:'#222'}}>
                            {solicitudes ? 'Solicitudes de Reservación' : 'Reservaciones de In/Out'}
                        </h2>
                        <Movimientos solicitudes={solicitudes} setId={setId}/>
                    </div>
                </div>
            </div>

        </div>
    )
}

const Movimientos = ({solicitudes, setId})=>{

    const { id } = useParams();
    const { token } = useToken();
    const navigate = useNavigate();
    const [tiempo, setTiempo] = useState('Month');
    const [data, setData] = useState([]);
    const [totales, setTotales] = useState({});
    const [filtros, setFiltros] = useState({status:'Total', requests: solicitudes});
    const [showFilter, setShowFilter] = useState('');
    const [fecha, setFecha] = useState(new Date())
    const [cargando, setCargando] = useState(false)
    const [tipoFiltro, setTipoFiltro] = useState('Todos');
    const modFiltrar = useRef();

    useEffect(()=>{
        if(token){
            getData();
        }
    },[token, filtros])

    const handleClickOutside = (event) => {
        if (modFiltrar.current && !modFiltrar.current.contains(event.target)) {
            setShowFilter('');
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const getData = ()=>{
        setCargando(true);
        filtros.idBooking = id;
        fetch(baseUrl+'Info/Inouts',{
            method: 'post',
            headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
            body: JSON.stringify(filtros)
        })
        .then(response=>response.json())
		.then(json=>{
            setData(json?.data || [])
            setTotales(json?.total || {});
            setCargando(false);
		})
		.catch(error=>{
			console.error(error);
            setCargando(false);
		})
    }

    const generaIntervalo = (json) => {
        if(json.intervalo > 1){
            return "En los últimos " + json.intervalo + " " + json.tiempo;
        }
        const singular = {
            "Días" : "Día",
            "Meses" : "Mes",
            "Años" : "Año",
        }
        return "En el último " + singular[json.tiempo];

    }

    return(
        <>
            
            {!solicitudes &&
            <>
                <div className="res-filter-pills">
                    <button
                        className={`res-filter-pill${filtros?.status == 'Total' ? ' active' : ''}`}
                        onClick={()=>{ setFiltros({...filtros, status: 'Total'}); }}
                    >
                        <span className="res-pill-label">Todos</span>
                        <span className="res-pill-count">{totales?.Total || 0}</span>
                    </button>
                    <button
                        className={`res-filter-pill${filtros?.status == 'Upcoming' ? ' active' : ''}`}
                        onClick={()=>{ setFiltros({...filtros, status: 'Upcoming'}); }}
                    >
                        <span className="res-pill-label">Próximos</span>
                        <span className="res-pill-count">{totales?.Upcoming || 0}</span>
                    </button>
                    <button
                        className={`res-filter-pill${filtros?.status == 'Ended' ? ' active' : ''}`}
                        onClick={()=>{ setFiltros({...filtros, status: 'Ended'}); }}
                    >
                        <span className="res-pill-label">Pasados</span>
                        <span className="res-pill-count">{totales?.Ended || 0}</span>
                    </button>
                    <button
                        className={`res-filter-pill${filtros?.status == 'Waiting' ? ' active' : ''}`}
                        onClick={()=>{ setFiltros({...filtros, status: 'Waiting'}); }}
                    >
                        <span className="res-pill-label">Esperando Aprobación</span>
                        <span className="res-pill-count">{totales?.Waiting || 0}</span>
                    </button>
                    <button
                        className={`res-filter-pill${filtros?.status == 'Rejected' ? ' active' : ''}`}
                        onClick={()=>{ setFiltros({...filtros, status: 'Rejected'}); }}
                    >
                        <span className="res-pill-label">Rechazados</span>
                        <span className="res-pill-count">{totales?.Rejected || 0}</span>
                    </button>
                </div>
            </>
            }

            <div className="res-filter-pills" style={{marginTop: "10px", marginBottom: "15px"}}>
                <button
                    className={`res-filter-pill${tipoFiltro == 'Todos' ? ' active' : ''}`}
                    onClick={()=>{ setTipoFiltro('Todos'); }}
                >
                    <span className="res-pill-label">Todos</span>
                </button>
                <button
                    className={`res-filter-pill${tipoFiltro == 'Entradas' ? ' active' : ''}`}
                    onClick={()=>{ setTipoFiltro('Entradas'); }}
                >
                    <span className="res-pill-label">Entradas</span>
                </button>
                <button
                    className={`res-filter-pill${tipoFiltro == 'Salidas' ? ' active' : ''}`}
                    onClick={()=>{ setTipoFiltro('Salidas'); }}
                >
                    <span className="res-pill-label">Salidas</span>
                </button>
            </div>

            <div className="filtrosPago">
                <span>
                    <button onClick={()=>{
                        setShowFilter('Importe')
                    }}>
                        {filtros?.price?.cond !== undefined &&
                            <button className="borrar" onClick={(e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                setFiltros({...filtros, price:undefined})
                            }}>
                                <img src={Cerrar}/>
                            </button>
                        }
                        <span>Importe</span>
                        {filtros?.price?.cond !== undefined && filtros.price.cond != "1" &&
                            <span className="lblFiltro">{Conds[filtros.price.cond]+" $"+formatoMoneda(filtros.price.values[0]*1)}</span>
                        }
                        {filtros?.price?.cond !== undefined && filtros.price.cond == "1" &&
                            <span className="lblFiltro">{"$"+formatoMoneda(filtros.price.values[0]*1)+" a $"+formatoMoneda(filtros.price.values[1]*1)}</span>
                        }
                    </button>
                    {showFilter == 'Importe' &&
                        <FiltrarImporte setShowFilter={setShowFilter} filtros={filtros} setFiltros={setFiltros} modFiltrar={modFiltrar}/>
                    }
                </span>
                <span>
                    <button onClick={()=>{
                        setShowFilter('Estatus')
                    }}>
                        {filtros?.statuses &&
                            <button className="borrar" onClick={(e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                setFiltros({...filtros, statuses:undefined})
                            }}>
                                <img src={Cerrar}/>
                            </button>
                        }
                        <span>Estatus</span>
                        {filtros?.statuses &&
                            <span className="lblFiltro">
                                {filtros?.statuses?.map(x=>{
                                    return estatus[x];
                                }).join(", ")}
                            </span>
                        }
                    </button>
                    {showFilter == 'Estatus' &&
                        <FiltrarEstatus setShowFilter={setShowFilter} filtros={filtros} setFiltros={setFiltros} modFiltrar={modFiltrar}/>
                    }
                </span>
                <span>
                    <button onClick={()=>{
                        setShowFilter('FechaI')
                    }}>
                        {filtros?.startDates?.cond !== undefined &&
                            <button className="borrar" onClick={(e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                setFiltros({...filtros, startDates:undefined})
                            }}>
                                <img src={Cerrar}/>
                            </button>
                        }
                        <span>Fecha</span>
                        {filtros?.startDates?.cond !== undefined && filtros.startDates.cond != "1" && filtros.startDates.cond < 4 &&
                            <span className="lblFiltro">{CondsFecha[filtros.startDates.cond]+" "+formatoFechaCorta(new Date(filtros.startDates.values[0].split("-")))}</span>
                        }
                        {filtros?.startDates?.cond !== undefined && filtros.startDates.cond == "1" &&
                            <span className="lblFiltro">{formatoFechaCorta(new Date(filtros.startDates.values[0].split("-")))+" al "+formatoFechaCorta(new Date(filtros.startDates.values[1].split("-")))}</span>
                        }
                        {filtros?.startDates?.cond !== undefined && filtros.startDates.cond == "4" &&
                            <span className="lblFiltro">{generaIntervalo(filtros.startDates)}</span>
                        }
                        {filtros?.startDates?.cond !== undefined && filtros.startDates.cond == "5" &&
                            <span className="lblFiltro">{generaIntervalo(filtros.startDates)}</span>
                        }
                    </button>
                    {showFilter == 'FechaI' &&
                        <FiltrarFecha setShowFilter={setShowFilter} showFilter={showFilter} filtrosDates={filtros?.startDates} setFiltros={setFiltros} modFiltrar={modFiltrar}/>
                    }
                </span>
            </div>
            <table className={"tabla pagos"+(cargando ? " cargandoTabla" : "")}>
            <tbody>
                {data?.length !== 0 &&
                    <tr className='header'>
                        <th>Almacén</th>
                        <th>Importe (MXN)</th>
                        <th>Estatus</th>
                        <th>Tipo</th>
                        <th>Pallets</th>
                        <th>Fecha</th>
                        <th>Hora</th>
                    </tr>
                }
                {data?.reduce((acc, fila) => {
                    if (fila.spacesIn > 0 && (tipoFiltro === 'Todos' || tipoFiltro === 'Entradas')) {
                        acc.push({...fila, isIN: true});
                    }
                    if (fila.spacesOut > 0 && (tipoFiltro === 'Todos' || tipoFiltro === 'Salidas')) {
                        acc.push({...fila, isIN: false});
                    }
                    return acc;
                }, []).length === 0 &&
                    <tr>
                        <td colSpan="8" style={{textAlign: "center", padding: "20px"}}>No hay movimientos recientes</td>
                    </tr>
                }
                {data?.reduce((acc, fila) => {
                    if (fila.spacesIn > 0 && (tipoFiltro === 'Todos' || tipoFiltro === 'Entradas')) {
                        acc.push({...fila, isIN: true});
                    }
                    if (fila.spacesOut > 0 && (tipoFiltro === 'Todos' || tipoFiltro === 'Salidas')) {
                        acc.push({...fila, isIN: false});
                    }
                    return acc;
                }, []).map((fila, i)=>{
                    console.log(fila)
                    let auxFecha = formatoFechaCorta(new Date(fila?.mainDate?.split("T")[0].split("-")));
                    if(auxFecha == formatoFechaCorta(new Date())){
                        auxFecha = "Hoy";
                    }
                    console.log(estatus, fila.status)
                    const isIN = fila.isIN;
                    return(
                        <tr key={i} onClick={()=>{
                            setId(fila.idInout);
                        }}>
                            <td>
                                <div className="cliente">
                                    {fila?.Photos?.[0]?.url &&
                                        <span className="imgPerfil">
                                            <img src={fila?.Photos?.[0]?.url}/>
                                        </span>
                                    }
                                    <span>{fila.name}</span>
                                </div>
                            </td>
                            <td>${formatoMoneda(fila.price*1)}</td>
                            <td>
                                <span className={fila.status}>
                                    <span>{estatus[fila.status]}</span>
                                    <img src={imgEstatus[fila.status]}/>
                                </span>
                            </td>
                            <td>{isIN ? "ENTRADA" : "SALIDA"}</td>
                            <td>{isIN ? fila?.spacesIn : fila?.spacesOut}</td>
                            <td>{formatoFechaCorta(new Date(fila.date.split("T")[0].split("-")))}</td>
                            <td>{fila?.time}</td>
                        </tr>
                    )
                })
                }
            </tbody>
            </table>
        </>
    )
}

const FiltrarImporte = ({setShowFilter, showFilter, filtros, setFiltros, modFiltrar})=>{
    const [tipo, setTipo] = useState(filtros?.price?.cond || 0);
    const value1 = useRef();
    const value2 = useRef();

    useEffect(()=>{
        value1.current.value = filtros?.price?.values[0];
        if(value2?.current)
            value2.current.value = filtros?.price?.values[1];
    }, [filtros])

    const aplicarFiltros = ()=>{
        if(!(
            value1?.current?.reportValidity() &&
            (!value2?.current || value2?.current?.reportValidity())
        )){
            return false;
        }

        setFiltros(filtros=> {
            return {...filtros, price: {
                cond: tipo,
                values: [value1.current.value, value2?.current?.value]
            }}
        })

        setShowFilter(false);
    }
    return(
        <div className="modFiltrar" ref={modFiltrar}>
            <h3>Filtrar por Importe</h3>
            <div>
                <select value={tipo} onChange={(e)=>{
                    setTipo(e.target.value)
                }}>
                    <option value='0'>Igual a</option>
                    <option value='1'>Entre </option>
                    <option value='2'>Mayor que</option>
                    <option value='3'>Menor que</option>
                </select>
            </div>
            <div className="defineRango">
                <label className="rango">
                    <img src={FlechaGuia}/>
                    <input type="number" ref={value1} required/>
                </label>
                {tipo == '1' &&
                    <>
                        <span className="guion"> — </span>
                        <label className="rango">
                            <input type="number" ref={value2} required/>
                        </label>
                    </>
                }
            </div>
            <div>
                <button className="btn" onClick={aplicarFiltros}>Aplicar</button>
            </div>
        </div>
    )
}

const FiltrarEstatus = ({setShowFilter, filtros, setFiltros, modFiltrar})=>{
    
    const [selected, setSelected] = useState(filtros?.statuses || []);
    
    const aplicarFiltros = ()=>{
        if(selected.length === 0){
            setFiltros(filtros=> {
                return {...filtros, statuses: undefined}
            })
        }
        else{
            setFiltros(filtros=> {
                return {...filtros, statuses: selected}
            })
        }

        setShowFilter(false);
    }

    return(
        <div className="modFiltrar" ref={modFiltrar}>
            <h3>Filtrar por Estatus</h3>
            <div className="lista">
                {Object.keys(estatus).map(x=>{
                    console.log(selected, x);
                    return(
                        <label key={x}>
                            <input type="checkbox" checked={selected.includes(x)} onChange={(e)=>{
                                if(selected.includes(x)){
                                    selected.splice(selected.indexOf(x), 1)
                                    setSelected([...selected])
                                }
                                else{
                                    selected.push(x)
                                    setSelected([...selected])
                                }
                            }}/>
                            <span>{estatus[x]}</span>
                        </label>
                    )
                })
                }
            </div>
            <div>
                <button className="btn" onClick={aplicarFiltros}>Aplicar</button>
            </div>
        </div>
    )
}
const FiltrarFecha = ({setShowFilter, showFilter, filtrosDates, setFiltros, modFiltrar})=>{
    console.log(filtrosDates)
    const [tipo, setTipo] = useState(filtrosDates?.cond || 4);
    const value1 = useRef();
    const value2 = useRef();
    const select = useRef();

    useEffect(()=>{
        if(filtrosDates?.cond < 4){
            value1.current.value = filtrosDates?.values[0];
            if(value2?.current)
                value2.current.value = filtrosDates?.values[1];
        }
        else{
            value1.current.value = 10;
        }
    }, [filtrosDates])

    const aplicarFiltros = ()=>{
        if(!(
            value1?.current?.reportValidity() &&
            (!value2?.current || value2?.current?.reportValidity())
        )){
            return false;
        }
        if(tipo < 4){
            setFiltros(filtros=> {
                if(showFilter == "FechaI")
                    return {...filtros, startDates: {
                    cond: tipo,
                    values: [value1.current.value, value2?.current?.value]
                }}

                return {...filtros, endDates: {
                    cond: tipo,
                    values: [value1.current.value, value2?.current?.value]
                }}
            })
        }
        else{
            const aux = [];
            
            const hoy = new Date();
            const auxDate = new Date();
            const intervalo = value1.current.value*1 || 1;

            if(tipo == 4){
                if(select.current.value == 'Días'){
                    auxDate.setDate(auxDate.getDate() - intervalo);
                }
                else if(select.current.value == 'Meses'){
                    auxDate.setMonth(auxDate.getMonth() - intervalo);
                }
                else if(select.current.value == 'Meses'){
                    auxDate.setFullYear(auxDate.getFullYear() - intervalo);
                }
                aux.push(formatoFecha(auxDate))
                aux.push(formatoFecha(hoy))
            }
            else{
                if(select.current.value == 'Días'){
                    auxDate.setDate(auxDate.getDate() + intervalo);
                }
                else if(select.current.value == 'Meses'){
                    auxDate.setMonth(auxDate.getMonth() + intervalo);
                }
                else if(select.current.value == 'Años'){
                    auxDate.setFullYear(auxDate.getFullYear() + intervalo);
                }
                aux.push(formatoFecha(hoy))
                aux.push(formatoFecha(auxDate))
            }
            console.log(aux);
            setFiltros(filtros=> {
                if(showFilter == "FechaI")
                    return {...filtros, startDates: {
                    cond: tipo,
                    values: aux,
                    tiempo: select.current.value,
                    intervalo
                }}

                return {...filtros, endDates: {
                    cond: tipo,
                    values: aux,
                    tiempo: select.current.value,
                    intervalo
                }}
            })
        }

        setShowFilter(false);
    }
    return(
        <div className="modFiltrar" ref={modFiltrar}>
            <h3>Filtrar por Fecha</h3>
            <div>
                <select value={tipo} onChange={(e)=>{
                    setTipo(e.target.value)
                }}>
                    <option value='4'>En los últimos</option>
                    <option value='5'>En los próximos</option>
                    <option value='0'>Igual a</option>
                    <option value='1'>Entre </option>
                    <option value='2'>Despues de</option>
                    <option value='3'>Antes de</option>
                </select>
            </div>
            <div className="defineRango">
                {tipo <= 3 &&
                    <>
                        <label className="rango">
                            <img src={FlechaGuia}/>
                            <input type="date" ref={value1} required/>
                        </label>
                        {tipo == '1' &&
                            <>
                                <span className="guion"> — </span>
                                <label className="rango">
                                    <input type="date" ref={value2} required/>
                                </label>
                            </>
                        }
                    </>
                }
                {tipo > 3 &&
                    <label className="rango">
                        <img src={FlechaGuia}/>
                        <input type="number" ref={value1} min={1} required/>
                        <select ref={select}>
                            <option>Días</option>
                            <option>Meses</option>
                            <option>Años</option>
                        </select>
                    </label>
                }
            </div>
            <div>
                <button className="btn" onClick={aplicarFiltros}>Aplicar</button>
            </div>
        </div>
    )
}

export default DashInouts;